













import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class UnauthorizedAccessPage extends Vue {

    private back() {
        this.$router.back();
    }
}
